import React from 'react';
// import newLogo from './path/to/new-logo.svg';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import Footer from './components/Footer';
import { AnimatePresence } from 'framer-motion';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AnimatePresence mode="wait">
          <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200">
            <Navbar />
            <main className="relative">
              <Dashboard />
            </main>
            <Footer />
          </div>
        </AnimatePresence>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
